<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
    class="inline-fa"
    :class="[{ 'inline-fa--spin': spin }]"
    aria-hidden="true"
    focusable="false"
  >
    <path fill="currentColor" :d="pathD" />
  </svg>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { ICON_PATHS, BRAND_PATHS } from '@/assets/iconPaths.js';

const props = defineProps({
  name: { type: String, required: true },
  brand: { type: Boolean, default: false },
  spin: { type: Boolean, default: false },
});

const meta = computed(() => {
  const src = props.brand ? BRAND_PATHS : ICON_PATHS;
  return src[props.name] || ICON_PATHS.tag;
});

const pathD = computed(() => meta.value?.d || '');
const viewBox = computed(() => meta.value?.viewBox || '0 0 512 512');
</script>

<style scoped>
.inline-fa {
  display: inline-block;
  vertical-align: -0.125em;
  width: 1em;
  height: 1em;
  overflow: visible;
}
.inline-fa--spin {
  animation: inline-fa-spin 0.85s linear infinite;
}
@keyframes inline-fa-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
